// Measurements must be in inches, so no ' or " (feet/inch marks) are accepted.
// Accepts whole numbers, decimals, bare fractions, a whole + fraction combined
// (fraction before or after the whole, separated by a space or "-"), and a
// dash-separated range of two whole/decimal numbers (parsed as their average):
// "34", "34.5", "1/2", "34 1/2", "34-1/2", "1/2 34", "1/2-34", "34-35".
const WHOLE_ONLY_RE = /^\d+(?:\.\d+)?$/;
const FRACTION_ONLY_RE = /^(\d+)\/(\d+)$/;
const WHOLE_THEN_FRACTION_RE = /^(\d+(?:\.\d+)?)[-\s](\d+)\/(\d+)$/;
const FRACTION_THEN_WHOLE_RE = /^(\d+)\/(\d+)[-\s](\d+(?:\.\d+)?)$/;
const WHOLE_RANGE_RE = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/;

function fraction(numerator, denominator) {
  return Number(denominator) === 0 ? NaN : Number(numerator) / Number(denominator);
}

export default function parseMeasurement(value) {
  const trimmed = String(value).trim();

  if (WHOLE_ONLY_RE.test(trimmed)) {
    return parseFloat(trimmed);
  }

  let match = trimmed.match(FRACTION_ONLY_RE);
  if (match) {
    const [, numerator, denominator] = match;
    return fraction(numerator, denominator);
  }

  match = trimmed.match(WHOLE_THEN_FRACTION_RE);
  if (match) {
    const [, whole, numerator, denominator] = match;
    return parseFloat(whole) + fraction(numerator, denominator);
  }

  match = trimmed.match(FRACTION_THEN_WHOLE_RE);
  if (match) {
    const [, numerator, denominator, whole] = match;
    return parseFloat(whole) + fraction(numerator, denominator);
  }

  match = trimmed.match(WHOLE_RANGE_RE);
  if (match) {
    const [, start, end] = match;
    return (parseFloat(start) + parseFloat(end)) / 2;
  }

  return NaN;
}

// Some measurement fields (door widths/heights) disallow decimal notation
// ("34.5") while still allowing fraction notation ("34 1/2").
export function hasDecimalNotation(value) {
  return String(value).includes('.');
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/measures/measurementParsing.js